module.exports = __webpack_public_path__ + "img/首页-顶部banner.3b460426.jpg";